import {useEffect, useRef} from "react";

import {IAmplitudeItemListContext, IAmplitudeViewItemOffer} from "./get_amplitude_view_item_event_properties";
import {trackAmplitudeInvestmentViewItem} from "./track_amplitude_investment_view_item";

interface IUseTrackAmplitudeInvestmentViewItemParams {
    offer: IAmplitudeViewItemOffer | null;
    itemListContext: IAmplitudeItemListContext | null;
    isCurrentRouteOffer: boolean;
    isItemListContextResolved: boolean;
}

export const useTrackAmplitudeInvestmentViewItem = (params: IUseTrackAmplitudeInvestmentViewItemParams) => {
    const {offer, itemListContext, isCurrentRouteOffer, isItemListContextResolved} = params;
    const lastTrackedOfferIdRef = useRef<number | null>(null);

    useEffect(() => {
        if (!offer || !isCurrentRouteOffer) {
            lastTrackedOfferIdRef.current = null;
            return;
        }

        if (!isItemListContextResolved || lastTrackedOfferIdRef.current === offer.id) {
            return;
        }

        lastTrackedOfferIdRef.current = offer.id;

        trackAmplitudeInvestmentViewItem({
            offer,
            itemListId: itemListContext?.itemListId,
            itemListName: itemListContext?.itemListName
        });
    }, [offer, isCurrentRouteOffer, isItemListContextResolved, itemListContext]);
};
import {useEffect, useRef} from "react";

import {IAmplitudeItemListContext, IAmplitudeViewItemOffer} from "./get_amplitude_view_item_event_properties";
import {trackAmplitudeInvestmentViewItem} from "./track_amplitude_investment_view_item";

interface IUseTrackAmplitudeInvestmentViewItemParams {
    offer: IAmplitudeViewItemOffer | null;
    itemListContext: IAmplitudeItemListContext | null;
    isCurrentRouteOffer: boolean;
    isItemListContextResolved: boolean;
}

export const useTrackAmplitudeInvestmentViewItem = (params: IUseTrackAmplitudeInvestmentViewItemParams) => {
    const {offer, itemListContext, isCurrentRouteOffer, isItemListContextResolved} = params;
    const lastTrackedOfferIdRef = useRef<number | null>(null);

    useEffect(() => {
        if (!offer || !isCurrentRouteOffer) {
            lastTrackedOfferIdRef.current = null;
            return;
        }

        if (!isItemListContextResolved || lastTrackedOfferIdRef.current === offer.id) {
            return;
        }

        lastTrackedOfferIdRef.current = offer.id;

        trackAmplitudeInvestmentViewItem({
            offer,
            itemListId: itemListContext?.itemListId,
            itemListName: itemListContext?.itemListName
        });
    }, [offer, isCurrentRouteOffer, isItemListContextResolved, itemListContext]);
};
